import { withStylePrefix } from '../common/withStylePrefix';
import { SidePanelActionsComponent, sidePanelActionsTemplate } from './SidePanelActions';
import styles from './SidePanelActions.styles.scss';
export const sidePanelActionsDefinition = {
    baseName: 'side-panel-actions',
    template: sidePanelActionsTemplate,
    styles: withStylePrefix(styles),
};
export const chameleonSidePanelActions = SidePanelActionsComponent.compose(sidePanelActionsDefinition);
